module.exports = __webpack_public_path__ + "static/img/tel.c25fbac.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tel.png
// module id = X/e+
// module chunks = 1